import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {
  Card,
  Dropdown,
  Table,
  Loader,
  Popup,
  Icon,
} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {pageSizes} from '../../../../common/constants/lists';
import {dateFormatReservation} from '../../../../common/constants/datesFormat';
import TablePaginator from '../../../../common/components/tablePaginator';

class ManualsOrdersTable extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  onPageClick(value) {
    this.props.changeOrdersListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeOrdersListPageSize(data.value);
  }

  renderActionsColumnHeader() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingManualsOrders,
        scopes.Edit
      )
    ) {
      return;
    }
    return <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>;
  }

  renderEditIcon(element) {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingManualsOrders,
        scopes.Edit
      )
    ) {
      return null;
    }

    return (
      <Table.Cell textAlign='center'>
        <Popup
          trigger={
            <Link
              to={
                `/picking/pedidos-manuales/editar/concesionario/${element.dealerId}/agencia` +
                `/${element.agencyId}/order/${element.orderNumber}`
              }
            >
              <Icon name='write' color='blue' size='large' />
            </Link>
          }
          content='Editar'
          position='top center'
          inverted
        />
      </Table.Cell>
    );
  }

  renderOrders() {
    const {orders} = this.props;
    if (!orders.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={6}>
            No hay pedidos que cumplan con los parámetros de búsqueda
          </Table.Cell>
        </Table.Row>
      );
    }

    return orders.map((element, index) => {
      const dateFormatted = element.date ?
        moment(element.date).format(dateFormatReservation) :
        '';
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.dealerName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.agencyName}</Table.Cell>
          <Table.Cell textAlign='center'>
            {dateFormatted.toUpperCase()}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.orderNumber}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.orderLocation} {element.orderType}
          </Table.Cell>
          {this.renderEditIcon(element)}
        </Table.Row>
      );
    });
  }

  renderData() {
    const {loadingOrders} = this.props;
    if (loadingOrders) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderOrders();
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <Card fluid raised className='primary-content'>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>
                Concesionario
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Agencia</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Fecha Pedido
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>No. Pedido</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>
                Tipo de Pedido
              </Table.HeaderCell>
              {this.renderActionsColumnHeader()}
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderData()}</Table.Body>

          {this.renderPagination()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingOrders': state.manualsOrders.loadingOrders,
    'orders': state.manualsOrders.ordersListByPage,
    'totalItems': state.manualsOrders.ordersList.length,
    'pageNumber': state.manualsOrders.pageNumber,
    'pageSize': state.manualsOrders.pageSize,
    'permissions': state.session.permissions,
  };
};

const {
  changeOrdersListPage,
  changeOrdersListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  changeOrdersListPage,
  changeOrdersListPageSize,
})(ManualsOrdersTable);
